<template>
<div class="chapter">
<div class="inner_page">
<p class="space"> </p>
<p class="copyright3"><a id="page_iv"></a><a id="Copyright">First published in Great Britain in 2015 by<br/>
<b>PEN &amp; SWORD MILITARY</b><br/>
An imprint of<br/>
Pen &amp; Sword Books Ltd<br/>
47 Church Street<br/>
Barnsley<br/>
South Yorkshire<br/>
S70 2AS</a></p><a id="Copyright">
<p class="copyright3">Copyright © John Grehan and Martin Mace, 2015</p>
<p class="copyright3">ISBN: 978-1-78346-210-0<br/>
EPUB ISBN: 978-1-47386-359-0<br/>
PRC ISBN: 978-1-47386-358-3</p>
<p class="copyright3">The right of John Grehan and Martin Mace to be identified as the authors of this work has been asserted by them in accordance with the Copyright, Designs and Patents Act 1988.</p>
<p class="copyright3">A CIP catalogue record for this book is available from the British Library.</p>
<p class="copyright3">All rights reserved. No part of this book may be reproduced or transmitted in any form or by any means, electronic or mechanical including photocopying, recording or by any information storage and retrieval system, without permission from the Publisher in writing.</p>
<p class="copyright3">Typeset by Concept, Huddersfield, West Yorkshire HD4 5JL.<br/>
Printed and bound in England by CPI Group (UK) Ltd, Croydon CR0 4YY.</p>
<p class="copyright3">Pen &amp; Sword Books Ltd incorporates the imprints of Pen &amp; Sword Archaeology, Atlas, Aviation, Battleground, Discovery, Family History, History, Maritime, Military, Naval, Politics, Railways, Select, Social History, Transport, True Crime, and Claymore Press, Frontline Books, Leo Cooper, Praetorian Press, Remember When, Seaforth Publishing and Wharncliffe.</p>
</a><p class="copyright3"><a id="Copyright">For a complete list of Pen &amp; Sword titles please contact<br/>
PEN &amp; SWORD BOOKS LIMITED<br/>
47 Church Street, Barnsley, South Yorkshire, S70 2AS, England<br/>
E-mail: </a><a href="mailto:enquiries@pen-and-sword.co.uk">enquiries@pen-and-sword.co.uk</a><br/>
Website: <a href="http://www.pen-and-sword.co.uk" target="_blank">www.pen-and-sword.co.uk</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Copyright.vue?1a5c09d2